import { render, staticRenderFns } from "./CamposAlteracaoData.vue?vue&type=template&id=1c6faf4a"
import script from "./CamposAlteracaoData.vue?vue&type=script&setup=true&lang=ts"
export * from "./CamposAlteracaoData.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CamposAlteracaoData.vue?vue&type=style&index=0&id=1c6faf4a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports